import { api } from './index';

// Types for tender document requirements
export interface TenderDocumentRequirement {
  id: string;
  tenderId: string;
  documentType: string;
  documentCategory?: 'FINANCIAL' | 'GENERAL' | 'TECHNICAL';
  isRequired: boolean;
  description?: string;
  order: number;
  createdAt: string;
  updatedAt: string;
}

export interface CreateRequirementDto {
  documentType: string;
  documentCategory?: 'FINANCIAL' | 'GENERAL' | 'TECHNICAL';
  isRequired?: boolean;
  description?: string;
  order?: number;
}

export interface UpdateRequirementDto extends Partial<CreateRequirementDto> {}

// API functions
export const tenderRequirementsApi = {
  // Create tender document requirement
  createRequirement: async (tenderId: string, data: CreateRequirementDto): Promise<TenderDocumentRequirement> => {
    const response = await api.post(`/tenders/${tenderId}/requirements`, data);
    return response.data;
  },

  // List tender document requirements (admin endpoint)
  listRequirements: async (tenderId: string): Promise<TenderDocumentRequirement[]> => {
    const response = await api.get(`/tenders/${tenderId}/requirements`);
    return response.data;
  },

  // List tender document requirements (vendor endpoint)
  listVendorRequirements: async (tenderId: string): Promise<TenderDocumentRequirement[]> => {
    const response = await api.get(`/vendors/tenders/${tenderId}/requirements`, {
      useVendorAuth: true, // Explicitly use vendor authentication
    });
    return response.data;
  },

  // Update tender document requirement
  updateRequirement: async (tenderId: string, requirementId: string, data: UpdateRequirementDto): Promise<TenderDocumentRequirement> => {
    const response = await api.put(`/tenders/${tenderId}/requirements/${requirementId}`, data);
    return response.data;
  },

  // Remove tender document requirement
  removeRequirement: async (tenderId: string, requirementId: string): Promise<void> => {
    await api.delete(`/tenders/${tenderId}/requirements/${requirementId}`);
  },
};
